import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { TilesWidget4 } from '../../../_metronic/partials/widgets'
import TableWidgetIPList from '../../../_metronic/partials/widgets/_new/tables/TableWidgetIPList'
import { MixedWidgetIpStats } from '../../../_metronic/partials/widgets/_new/mixed/MixedWidgetIpStats'
import { useResourceAnalytics } from '../../hooks/useResourceAnalytics'
import { ChartsWidgetVerdictBifurcation } from '../../../_metronic/partials/widgets/_new/charts/ChartsWidgetVerdictBifurcation'
import { useAuth } from '../../modules/auth/core/Auth'
import KybReviewPage from './KybReviewPage'

const DashboardPage = () => {
  const intl = useIntl()
  const { ipVerdictStats, ipVerdictTotal, ipSelfStats } = useResourceAnalytics()

  const ipStatsData = {
    ipaddress_count: {
      total: ipVerdictTotal,
      enabled: ipSelfStats.whitelisted,
      disabled: ipSelfStats.blacklisted,
    },
  }

  return (
    <>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-4'>
          <MixedWidgetIpStats
            className='card-xxl-stretch mb-xl-3'
            chartColor='success'
            chartHeight='150px'
            data={ipStatsData}
            data1={null}
          />
        </div>

        <div className='col-xl-8'>
          <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8'>
            {/* <div className='col-xl-3'>
              <TilesWidget1 className='card-xl-stretch' />
            </div> */}
            <div className='col-xl-9 flex-grow-1'>
              <TilesWidget4 className='card-xl-stretch' />
            </div>
          </div>

          <div className='row gx-5 gx-xl-8 mb-5 mb-xl-8'>
            <div className='col-xl-12'>
              {/* <CardsWidget17
                className='card-xl-stretch mb-5 mb-xl-8'
                id="1"
                title="Whitelist Logs"
                data={data?.ipaddress_count}
              />
              <div className='row gx-5 gx-xl-8'>
                <div className='col-xl-6'>
                  <TilesWidget5
                    className='card-xxl-stretch bg-primary'
                    svgIcon='element-11'
                    titleClass='text-white'
                    descriptionClass='text-white'
                    iconClass='text-white'
                    title='0'
                    description='Total SMS Sent'
                  />
                </div>
                <div className='col-xl-6'>
                  <TilesWidget5
                    className='card-xxl-stretch bg-body'
                    svgIcon='rocket'
                    titleClass='text-dark'
                    descriptionClass='text-muted'
                    iconClass='text-success'
                    title='0'
                    description='Total SMS Failed'
                  />
                </div>
              </div> */}
              {/* <div
                className={'card bgi-no-repeat bgi-size-contain'}
                style={{
                  minHeight: "310px",
                  backgroundColor: '#fff',
                  // backgroundPosition: 'right bottom',
                  // backgroundSize: '50%',
                  // backgroundImage: `url("${toAbsoluteUrl('/media/svg/misc/eolic-energy.svg')}")`,
                }}
              >
                <div className='card card-body d-flex flex-column justify-content-between'>
                  <h2 className='fw-bold m-0'>
                    Whitelist Logs <br />
                  </h2>

                  <div className='d-flex flex-column'>
                    <div className='d-flex fw-semibold align-items-center'>
                      <div className='bullet w-8px h-3px rounded-2 bg-success me-3'></div>
                      <div className='text-gray-500 flex-grow-1'>Whitelisted</div>
                      <div className='ms-5 fw-bolder text-gray-700'>{data?.ipaddress_count?.whitelisted || 0}</div>
                    </div>
                    <div className='d-flex fw-semibold align-items-center mt-4'>
                      <div className='bullet w-8px h-3px rounded-2 bg-danger me-3'></div>
                      <div className='text-gray-500 flex-grow-1'>Blacklisted</div>
                      <div className='ms-5 fw-bolder text-gray-700'>{data?.ipaddress_count?.blacklisted || 0}</div>
                    </div>
                  </div>

                  <div className='d-flex justify-content-center pt-0'>
                    <div
                      id={'kt_card_widget_17_chart12'}
                      ref={chartRef}
                      // style={{ minWidth: chartSize + 'px', minHeight: chartSize + 'px' }}
                      // data-kt-size={chartSize}
                      // data-kt-line={chartLine}
                      style={{ height: chartSize + 'px' }}
                    ></div>
                  </div>

                </div>
              </div> */}

              <ChartsWidgetVerdictBifurcation
                className='card-xl-stretch mb-5 mb-xl-8'
                title={intl.formatMessage({ id: 'DASHBOARD.CHART.IP_REGISTRATION_SUMMARY' })}
                totalLabel={intl.formatMessage({ id: 'DASHBOARD.CHART.IPS_REGISTERED_LABEL' })}
                operatorData={ipVerdictStats}
                totalCount={ipVerdictTotal}
              />
            </div>
            {/* <div className='col-xl-6'> */}
              {/* <TilesWidget2 className='card-xl-stretch h-100 mb-5 mb-xl-8' /> */}
              {/* <TilesWidget3 className='card-xl-stretch mb-5 mb-xl-8' /> */}
            {/* </div> */}
          </div>
        </div>
      </div>

      <div className='row g-5 g-xl-8'>
        <div className='col-12'>
          <TableWidgetIPList className='card-xxl-stretch mb-5 mb-xl-10' />
        </div>
      </div>
    </>
  )
}

const DashboardWrapper = () => {
  const intl = useIntl()
  const { auth } = useAuth()

  if (auth?.flow === 'kyb') {
    return (
      <>
        <PageTitle breadcrumbs={[]}>KYB Review</PageTitle>
        <KybReviewPage />
      </>
    )
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
